import React from "react";

import Header from "../../components/Header/Header";
import Intro from "../../sections/Intro/Intro";
import Reviews from "../../sections/Reviews/Reviews";
import Included from "./Included";
import Pricing from "./Pricing";
import Footer from "../../components/Footer/Footer";

const Bookkeeping = () => {
  const reviews = [
    {
      text: "I have used Anika with Crystal Clear Consulting for years. She is very structured in her work. Every month, she documents month-end close spreadsheets that very all balance sheet accounts making every single month auditable...",
      author: "Retail Consulting Team",
    },
    {
      text: "Anika doesn't just check boxes; she stay ahead of the game, catching details I would've missed... she is super organized and great at follow up with helpful reminders. I now have more time for new client relationships and focusing on the bigger picture because our bookkeeping is done.",
      author: "Armormax Ghana",
    },
    {
      text: "I have been with Anika for 3 years now and she is the best! She is very intelligent in her field and she knows exactly what she is doing. This is my very first time running my own business and she has been with me every step of the way. I genuinely couldn't have done it without her.",
      author: "Mckenzie Talbot Photography",
    },
    {
      text: "I was referred to Crystal Clear Consulting and I couldn't be happier with the choice. I needed help managing my books and what I got instead was a professional, easy going, understanding, helpful and wealth of knowledge company that is dedicated towards your companies success.",
      author: "Robert Ritchey",
    },
  ];
  return (
    <div className="column">
      <Header />
      <Intro
        primary="Rely on accurate, up-to-date books."
        secondary="By-the-book bookkeeping for businesses that take their finances seriously."
      />

      <Reviews reviews={reviews} />

      <img
        className="crystals_light crystals_flipped"
        src={require("../../images/crystals_light.png")}
        alt="crystals"
      />

      <Included />

      <Pricing />

      <div className="container background_white">
        <div className="column w64 g1">
          <h2>Do It Yourself</h2>
          <p className="ctext">
            If you prefer to do your own bookkeeping, our free finance tracker
            will help you keep track of everything you need.
          </p>
          <div className="columns g1">
            <a
              className="link"
              href="https://docs.google.com/spreadsheets/d/1bKZLREVNX3wLr1QKKRfvTmpNpiqibF-VJGkwZqsaa78/template/preview"
              rel="noopener noreferrer"
              target="_blank"
            >
              Copy Google Sheets template
            </a>
            <a
              className="link"
              href="https://storage.googleapis.com/crystalclearconsulting.appspot.com/Financial%20Tracker.xlsx"
              download
            >
              Download for Excel
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Bookkeeping;
